import { useEffect, useState } from "react";
import Footer from "../../../components/Footer/Footer";
import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Griha.scss";
import MuhuratLink from "../../../components/MuhuratLink/MuhuratLink";
import axios from "axios";
import city from '../../../city.json'

const Griha = () => {
  const [expandedMonths, setExpandedMonths] = useState({});
  const [grihaData, setGrihaData] = useState({});
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [location, setLocation] = useState("Kolkata");
  const [tempYear, setTempYear] = useState(currentYear);
  const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const handleToggle = (index) => {
    setExpandedMonths((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const fetchGrihaData = async () => {
      try {
        const res = await axios.get(
          `https://core-c343.onrender.com/api/griha-Pravesh?year=${year}&location=${encodeURIComponent(location)}`
        );
        const data = await res.data;
        setGrihaData(data?.grihaPraveshMuhurat || {});
      } catch (err) {
        console.error("Failed to fetch Griha Pravesh Muhurat data:", err);
      }
    };
    fetchGrihaData();
  }, [year, location]);

  const formatDate = (dateStr) => {
    const [yyyy, mm, dd] = dateStr.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };

  const handleSubmit = () => {
    setYear(tempYear);
    setLocation(tempLocation);
  };

    const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };
  const monthKeys = Object.keys(grihaData);

  return (
    <div className="Griha-container">
      <InnerNav />
      <div className="Griha-content">
        <Zodiac />

        <div className="location-date">
          <div className="year-selector">
            <label htmlFor="year">Select Year: </label>
            <input
              id="year"
              type="number"
              min="1900"
              max="2100"
              value={tempYear}
              onChange={(e) => setTempYear(Number(e.target.value))}
            />
            <button className="submit" onClick={handleSubmit}>Submit</button>
          </div>

           <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
        </div>

        <div className="meaning">
          <p className="meaning1">⚠️: Not Recommended / Ashubh Muhurat</p>
          <p className="meaning1">✅: Shubh Muhurat</p>
        </div>

        <h1 className="Griha-title">Griha Pravesh Muhurat</h1>

        {monthKeys.length > 0 ? (
          monthKeys.map((month, index) => {
            const isExpanded = expandedMonths[index];
            const entries = grihaData[month] || [];
            const visibleGriha = isExpanded ? entries : entries.slice(0, 6);

            return (
              <div className="monthVivah" key={index}>
                <h2 className="monthh-heading">{month}, {year}</h2>
                <div className="list-of-Griha">
                  {visibleGriha.map((item, i) => (
                    <div className="Griha-card" key={i}>
                      <div className="Griha-info">
                        <p className="tag">{item.tag ? item.tag.slice(0, 2) : ""}</p>
                        <p><strong>Date:</strong> {formatDate(item.date)}</p>
                        {item.weekday && <p><strong>Weekday:</strong> {item.weekday}</p>}
                        {item.tithi && <p><strong>Tithi:</strong> {item.tithi}</p>}
                        {item.nakshatra && <p><strong>Nakshatra:</strong> {item.nakshatra}</p>}
                        {item.verdict && <p><strong>Verdict:</strong> {item.verdict}</p>}
                        {item.rating && <p><strong>Rating:</strong> {item.rating}</p>}
                        {item.score !== undefined && <p><strong>Score:</strong> {item.score}</p>}
                      </div>
                    </div>
                  ))}
                </div>

                {entries.length > 6 && (
                  <button className="toggle-btn" onClick={() => handleToggle(index)}>
                    {isExpanded ? "Show less" : "Show more"}
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <p>No Griha Pravesh data available for the current year.</p>
        )}

        <section className="vivah-wrapper">
          <h1 className="vivah-title">About Griha Pravesh</h1>
          <div className="vivah-texts">
            <p>
              Auspicious Griha Pravesh dates are calculated after Panchang Shuddhi. Panchang Shuddhi gives not only auspicious dates but also Shubh times for Griha Pravesh Puja, Homam, and Vastu Shanti.
            </p>

            <p>
              Most auspicious ceremonies, especially Marriage and House Entry, are prohibited during the combustion of Venus (Shukra). Click <span
                className="link-text"
                onClick={() => setShowPopup(true)}>Shukra Asta</span> to learn more about this event and its timings.
            </p>

            <p>
              Only Muhurats lasting at least 5 minutes are considered, calculated from sunrise to sunrise. Dates and timings are location-based, so set your city before checking Shubh Muhurat.
            </p>
          </div>
        </section>

        <MuhuratLink />
      </div>
      <Footer />


      {/* Popup Modal */}
      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>Shukra Asta (Venus Combustion)</h2>
            <p>
              Combustion of a planet is a significant event in Vedic astrology. Venus becomes very close to the Sun and is not visible for a few days. These periods are called Asta, Lope, Moudhya, or Moudyami.
            </p>
            <p>
              Most auspicious ceremonies, including Marriage and Griha Pravesh, are prohibited during Venus combustion.
            </p>
            <p>
              Approximate timings of Venus Asta can be calculated using angular separation: 10° on both sides of the Sun when Venus is in forward motion, 8° when in retrograde motion. Modern algorithms can predict precise date and time based on your location.
            </p>
            <button className="popup-close" onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Griha;
